const httpProviderConfig = ($httpProvider) => {
  'ngInject';

  $httpProvider.interceptors.push('appAPIVersionInterceptor');
  $httpProvider.interceptors.push('appAuthInterception');
};

export default httpProviderConfig;
